import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { AnswerDisplay, CompletedPollQuestion } from '@fgb/core';

@Component({
  selector: 'fgbcl-game-polls-result',
  templateUrl: './game-polls-result.component.html',
  styleUrl: './game-polls-result.component.scss',
  animations: [
    trigger('pointsAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.5)' }),
        animate('0.5s ease-out', style({ opacity: 1, transform: 'scale(1)' })),
      ]),
      transition(':leave', [animate('0.3s ease-in', style({ opacity: 0, transform: 'scale(0.5)' }))]),
    ]),
  ],
})
export class GamePollsResultComponent implements OnInit {
  @Input() pollsQuestions: CompletedPollQuestion;
  answerType = AnswerDisplay;
  @Input() disableAnimation!: boolean;
  @Input() pointIcon: string = 'loyalty';
  ngOnInit(): void {}
}
